@if (totalProviderChargesConfig?.totalProviderChargesOption) {
  <simple-card class="TotalProviderChargesReview__SimpleCard">
    <div
      title
      class="TotalProviderChargesReview__Title"
      data-test-id="TotalProviderChargesReviewTitle"
    >
      <h6 class="t-bold">{{ totalProviderChargesConfig.title }}</h6>
    </div>
    <div class="TotalProviderChargesReview__TotalProviderCharges">
      <div class="TotalProviderChargesReview__TotalProviderChargesLabel">
        {{ totalProviderChargesConfig.totalProviderChargesOption.label }}
      </div>
      <div class="TotalProviderChargesReview__TotalProviderChargesValue">
        {{ totalClaimLineCharges | currency }}
      </div>
    </div>
  </simple-card>
}
